"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("./utils");

var _constants = require("./constants");

var _lastTimestampFromPricesMap = _interopRequireDefault(require("./last-timestamp-from-prices-map"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getLimit = ({
  granularity,
  history,
  requestLimit,
  requestTimestamp,
  specificTimestamp
}) => {
  if (specificTimestamp) return 1;
  const lastCachedTime = (0, _lastTimestampFromPricesMap.default)(history);
  const limitFromOptions = requestLimit || _constants.LIMIT[granularity];

  if (granularity === 'hour') {
    if (!lastCachedTime) return limitFromOptions;
    return Math.min(limitFromOptions, (0, _utils.timeToHours)(requestTimestamp - lastCachedTime));
  }

  return Math.min(limitFromOptions, (0, _utils.timeToDays)(requestTimestamp - (lastCachedTime || _constants.START_TIME)));
};

var _default = getLimit;
exports.default = _default;